import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FieldType } from '../templates/field.type';
var FormlyGroup = (function (_super) {
    tslib_1.__extends(FormlyGroup, _super);
    function FormlyGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormlyGroup.prototype, "newOptions", {
        get: function () {
            return tslib_1.__assign({}, this.options);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyGroup.prototype, "formlyGroup", {
        get: function () {
            if (this.field.formControl) {
                return this.field.formControl;
            }
            else {
                return this.form;
            }
        },
        enumerable: true,
        configurable: true
    });
    return FormlyGroup;
}(FieldType));
FormlyGroup = tslib_1.__decorate([
    Component({
        selector: 'formly-group',
        template: "\n    <formly-form [fields]=\"field.fieldGroup\" [model]=\"model\" [form]=\"formlyGroup\" [options]=\"newOptions\" [ngClass]=\"field.fieldGroupClassName\" [buildForm]=\"false\"></formly-form>\n  ",
    })
], FormlyGroup);
export { FormlyGroup };
//# sourceMappingURL=formly.group.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/components/formly.group.js
// module id = 325
// module chunks = 3